/**
 * Created by pmnia on 8/29/15.
 */
(function(app){
    angular
        .module('app.widgets')
        .filter('momentFormat',momentFormatFilter);
    function momentFormatFilter(){
        return function(input) {
            input = input || '';
            if(moment.isMoment(input)){
                return input.format('DD-MM-YYYY, HH:mm');
            }else{
                return input;
            }
        };
    }
})();



/*****************
 ** WEBPACK FOOTER
 ** ./app/widgets/obt-moment.filters.js
 ** module id = 189
 ** module chunks = 0
 **/